import React from 'react';
import './iconBadge.css';

export default class IconBadge extends React.Component {
	render() {
		const { count, left } = this.props;
		return <div className="icon-frame" style={{ left: `${left}px` }}><div className="icon-badge">{count}</div></div>
	}
}